
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/fansi-class",
      function () {
        return require("private-next-pages/products/fansi-class/index.tsx");
      }
    ]);
  